import { useStore } from '@tanstack/react-form';
import { ProfilePhotoEditor } from '../profile-photo/ProfilePhotoEditor';
import type { DetailFormJsMethodProps } from './registry';
import {
  getEmployeePhotoValue,
  getEmployeePhotoInitials,
  toPositiveInteger,
} from './employeePhotoHelpers';

export const EmployeePhotoJsMethodBinding = ({
  fields,
  form,
  onNotify,
}: DetailFormJsMethodProps) => {
  const values = useStore(form.store, (state) => {
    return ((state as { values?: Record<string, unknown> }).values ?? {}) as Record<
      string,
      unknown
    >;
  });
  const relationId = toPositiveInteger(getEmployeePhotoValue(values, fields, 'Id'));

  if (relationId == null) {
    return null;
  }

  return (
    <ProfilePhotoEditor
      relationId={relationId}
      initials={getEmployeePhotoInitials(
        getEmployeePhotoValue(values, fields, 'CrmRelationInitials'),
        getEmployeePhotoValue(values, fields, 'CrmRelationName')
      )}
      onError={(message) => onNotify({ severity: 'error', message })}
    />
  );
};
